"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var internal = {
    tdOrTh: {
        fontWeight: 'normal',
    },
};
exports.default = (function (muiTheme, style) { return ({
    gridWrapper: __assign({ overflow: 'auto', padding: '0 20px 20px 0', boxSizing: 'border-box' }, style),
    grid: {
        borderCollapse: 'collapse',
        fontFamily: 'Roboto, sans-serif',
        width: '100%',
        minWidth: 850,
    },
    caption: {
        minHeight: muiTheme.tableCaption.height,
        captionSide: muiTheme.tableCaption.side || 'auto',
    },
    buttonBar: {
        display: 'flex',
        alignItems: 'flex-start',
        height: muiTheme.tableCaption.height,
    },
    columnList: {
        height: 400,
        maxHeight: 400,
        overflowY: 'scroll',
    },
    theadTr: {
        fontSize: muiTheme.tableHeaderColumn.fontSize,
        height: muiTheme.tableHeaderColumn.height,
    },
    theadCheckbox: {},
    theadTh: __assign({}, internal.tdOrTh, { borderBottomWidth: 1, borderBottomStyle: 'solid', borderColor: muiTheme.tableHeader.borderColor, color: muiTheme.tableHeaderColumn.textColor, paddingLeft: 10, paddingRight: 10, cursor: 'pointer' }),
    theadThSorted: {
        color: muiTheme.tableHeaderColumn.sortedColor,
    },
    theadThSpan: {
        cursor: 'pointer',
    },
    sortIconWrapper: {
        verticalAlign: 'middle',
        display: 'inline-block',
    },
    sortIcon: {
        color: muiTheme.tableHeaderColumn.textColor,
    },
    sortIconSorted: {
        color: muiTheme.tableHeaderColumn.sortedColor,
    },
    tbodyTr: {
        fontSize: muiTheme.tableRow.fontSize,
        height: muiTheme.tableRow.height,
    },
    tbodyTd: {
        borderBottomWidth: 1,
        borderBottomStyle: 'solid',
        borderColor: muiTheme.tableRow.borderColor,
        paddingLeft: 10,
        paddingRight: 10,
    },
    footerTd: {
        textAlign: 'right',
        fontSize: muiTheme.tableFooter.fontSize,
        color: muiTheme.tableFooter.textColor,
    },
    footerSelect: {
        verticalAlign: 'middle',
        width: 130,
    },
    footerPage: {
        verticalAlign: 'middle',
        width: 100,
    },
    footerNext: {
        verticalAlign: 'middle',
        marginRight: -12,
    },
    footerPrevious: {
        verticalAlign: 'middle',
    },
    hidden: {
        display: 'none',
    },
    renderer: {
        text: {
            textAlign: 'left',
        },
        other: {
            textAlign: 'right',
        },
    },
    filtersCaption: {
        textAlign: 'left',
        marginTop: 0,
        fontSize: muiTheme.tableFilters.fontSize,
        borderBottom: '1px solid rgb(238, 238, 238)',
        height: muiTheme.tableFilters.height,
    },
    filtersAdd: {
        verticalAlign: 'middle',
    },
    filtersRemoveAll: {
        verticalAlign: 'middle',
    },
    filtersSearchAll: {
        verticalAlign: 'middle',
    },
    filtersTitle: {
        verticalAlign: 'middle',
        fontWeight: 'bold',
    },
    filters: {
        listStyleType: 'none',
        padding: 0,
    },
    filterRow: {
        textAlign: 'left',
    },
    filterRowRemove: {
        verticalAlign: 'middle',
    },
    filterGridRow: {
        backgroundColor: lodash_1.get(muiTheme, 'grid.filterRow.backgroundColor', 'transparent'),
    },
    filterRowColumn: {
        verticalAlign: 'middle',
        marginRight: 15,
    },
    filterRowOperation: {
        verticalAlign: 'middle',
        marginRight: 15,
    },
    filterRowValue: {
        verticalAlign: 'middle',
        marginRight: 15,
    },
    filterAggregation: {
        verticalAlign: 'middle',
        marginLeft: 15,
    },
}); });
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Grid/styles.js
// module id = 1929
// module chunks = 0